import React from 'react'
import PropTypes from 'prop-types'
import {
  TYPE_CONTENT_PERSON,
} from '../../services/content-type/index'
import TileV2Hero from './Tile.v2Hero'
import TileV2InfoMetadata from './Tile.v2InfoMetadata'
import TileV2GraphqlHero from './Tile.v2Graphql/Tile.v2GraphqlHero'
import TileV2GraphqlInfoMetadata from './Tile.v2Graphql/Tile.v2GraphqlInfoMetadata'

import {
  getTileV2ElementClassName,
} from './utils'

/**
 * The info for a tile, the hover state
 * @param {Object} props - The props
 * @param {Boolean} props.isTouchable - Whether or not the tile is being displayed on a touch device
 * @param {String} props.contentType - The type of content
 * @param {Boolean} props.hovered - Whether or not the tile is in the over state
 * @param {String} props.display - The display type
 * @returns {JSX.Element} The tile hover info components
 */
function TileV2Info (props) {
  const {
    isTouchable,
    contentType,
    hovered,
    display,
    useGraphQL,
  } = props

  if (isTouchable) {
    return null
  }

  if (contentType === TYPE_CONTENT_PERSON) {
    return null
  }

  return (
    <div className={
      getTileV2ElementClassName({
        hovered, display, contentType, baseClassName: 'tile-v2__info',
      })
    }>
      {
        useGraphQL
          ? <>
              <TileV2GraphqlHero {...props} />
              <TileV2GraphqlInfoMetadata {...props} />
            </>
          : <>
              <TileV2Hero
                {...props}
              />
              <TileV2InfoMetadata
                {...props}
              />
            </>
      }
    </div>
  )
}

TileV2Info.propTypes = {
  useGraphQL: PropTypes.bool,
}

TileV2Info.defaultProps = {
  useGraphQL: false,
}

export default TileV2Info
